import { render, staticRenderFns } from "./MatriculasComplementarCard.vue?vue&type=template&id=0a265a0b&scoped=true"
import script from "./MatriculasComplementarCard.vue?vue&type=script&lang=js"
export * from "./MatriculasComplementarCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasComplementarCard.vue?vue&type=style&index=0&id=0a265a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a265a0b",
  null
  
)

export default component.exports